import * as Sentry from '@sentry/browser';
import { useEffect } from 'react';
import { getEnvVariable } from '../utils/getEnvVariable';

const FALLBACK_DSN =
  'https://a62463aad16053fd10a70330b4640af0@o4509129008087040.ingest.us.sentry.io/4509129008349184';

export const useSentry = () => {
  const dsn = getEnvVariable('REACT_APP_SENTRY_DSN', FALLBACK_DSN);

  useEffect(() => {
    if (!dsn) return;
    Sentry.init({
      dsn,
      release: getEnvVariable('REACT_APP_HEROKU_RELEASE_VERSION', 'unknown'),
      ignoreErrors: [/network error/i, /Failed to fetch/i]
    });
  }, [dsn]);
};
